<template>
  <!-- 사업장별 온실가스 배출량 -->
  <esg-base-dashboard-card :title="`${corporation.name} 사업장별 온실가스 배출량`">
    <b-container fluid>
      <b-row align-h="around">
        <template v-for="businessLocation in businessLocations">
          <b-col :key="`${businessLocation.corporation_code} ${businessLocation.business_location_code}`"
                 lg="4">
            <emission-by-scope-for-biz-loc :business-location="businessLocation"/>
          </b-col>
        </template>
      </b-row>
    </b-container>
  </esg-base-dashboard-card>
  <!-- /사업장별 온실가스 배출량 -->
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EmissionByScopeForBizLoc from "../charts2/BizLocEmissionByScope.vue";

export default {
  props: {
    corporation: {
      type: Object,
      required: true,
    }
  },
  components: {
    EmissionByScopeForBizLoc,
    EsgBaseDashboardCard,
  },
  watch: {
    corporation: {
      deep: true,
      immediate: true,
      handler(newCorp, oldCorp) {
        if (!oldCorp || newCorp.code !== oldCorp.code) {
          this.fetchBusinessLocations();
        }
      }
    }
  },
  data() {
    return {
      businessLocations: []
    }
  },
  methods: {
    async fetchBusinessLocations() {
      if (!this.corporation || !this.corporation.code) return;

      try {
        let response = await axios.get('esg/lca/business-location', {
          headers: { Authorization: accessToken() },
          params: {
            filters: [
              {
                name: 'esg_base_corporation.tenant_id',
                value: this.tenantId(),
                operation: 'EQUAL'
              },
              {
                name: 'esg_base_corporation.code',
                value: this.corporation.code,
                operation: 'EQUAL'
              }
            ]
          }
        });
        this.businessLocations = response.data.list;
      } catch (error) {
        await this.showError(error);
      }
    },
  }
}
</script>